import * as types from '../constants/actionTypes/login';
import { loginService, getUserName, loginWithAzureAD, getUserRoleFromToken } from '../services/aws/aws-services';
import { logger } from '../services/logger/logger-service';
import { loggerEventOutcome, loggerEventTypes, loggerEventName, loggerEventMessage, errorMessages } from '../helpers/messages';
import { activityUpdater } from '../services/activity/activity-service';
import { removeLocalStorage, setLocalStorage, setSessionStorage } from '../services/storage/storage-service';
import { getUserRoleFromAPI } from '../services/java/java-services';
import { MappingRoles } from '../helpers/constants';

export function loginSuccess(res) {
	return { type: types.LOGIN_USER_SUCCESS, res };
}

export function loginError(err) {
	return { type: types.LOGIN_USER_ERROR, err };
}

export function newPasswordRequired(res) {
	return { type: types.NEW_PASSWORD_REQUIRED, res };
}
/**
 * @description function to handle application logs
 * @param {*}
 * @memberof loginaction
 */
/* istanbul ignore next  */
export const applicationLogger = () => {
	const loggerObj = {
		"EventOutcome": loggerEventOutcome.success,
		"EventType": loggerEventTypes.login,
		"EventName": loggerEventName.login,
		"Content": {
			"Data": loggerEventMessage.login
		}
	}
	logger(loggerObj);
}

/**
 * @description function to handle user login activity
 * @param userObj Cognito User data
 * @memberof loginaction
 */
/* istanbul ignore next  */
const updateActivity = (userObj) => {
	var userName = getUserName() || userObj.username;
	if (userName) {
		const activityObj = {
			lastLoginTime: new Date().toISOString(),
			userName: userName
		}
		activityUpdater(activityObj);
	}
}

/**
 * @description function to handle user login activity for AD users
 * @param userObj Cognito User data
 * @memberof loginaction
 */
/* istanbul ignore next  */
const updateActivityADUser = (userObj) => {
	var userName = getUserName() || userObj.username;
	if (userName) {
		const activityObj = {
			lastLoginTime: new Date().toISOString(),
			email: userObj.email,
			isADUser: true,
			userName: userObj['cognito:username']
		}
		activityUpdater(activityObj);
	}
}

/**
 * @description function to handle after login details
 * @param userObj Cognito User data
 * @memberof loginaction
 */
/* istanbul ignore next  */
export const handleLogin = (userObj, shouldUpdateUser = true) => {
	removeLocalStorage('isFirstLogin');
	setSessionStorage('useractivestatus', true);
	setLocalStorage('cognito_data', JSON.stringify(userObj.attributes));
	setLocalStorage('userRole', getUserRoleFromToken());
	applicationLogger();
	if (shouldUpdateUser) {
		updateActivity(userObj);
	}
}

/**
 * @description function to handle after login details for AD users
 * @param cognitoUser Cognito User data
 * @memberof loginaction
 */
/* istanbul ignore next  */
export const handleADLogin = (cognitoUser) => {
	setSessionStorage('useractivestatus', true);
	setLocalStorage('userType', 'AD_User')
	let userObj = cognitoUser?.signInUserSession?.idToken?.payload || null;
	setLocalStorage('cognito_data', JSON.stringify(userObj));
	updateActivityADUser(userObj)
}

/**
 * @description function to role details for AD users
 * @memberof loginaction
 */
/* istanbul ignore next  */
export const getRoleFromBackendAPI = () => {
	return new Promise((resolve, reject) => {
		getUserRoleFromAPI((err, res) => {
			if (err) {
				return reject(err);
			}
			if (res) {
				if (!res.data || !Object.keys(res.data).length) {
					reject({ errorMessage: errorMessages.generic })
				}

				const { data } = res;
				let mappedRoleObj = MappingRoles.find(x => x.userRole === data?.daprole);
				let roleObj = {
					userRole: data?.daprole,
					roleDisplayName: mappedRoleObj?.specialLabel
				}
				setLocalStorage('ADUserRoleObj', JSON.stringify(roleObj));
				setLocalStorage('userRole', roleObj.userRole);
				return resolve(roleObj);
			}
		})
	})
}

/* istanbul ignore next  */
export function authUser(params) {
	return (dispatch) => {
		if (!params || !params?.source) {
			return dispatch(loginError({ message: 'Auth process invalid.' }));
		}
		const { source, attributes } = params;
		switch (source) {
			case "federated":
				loginWithAzureAD();
				break;
			case "legacy":
				if (!attributes || !attributes.username || !attributes.password) {
					return dispatch(loginError({ message: 'No username or password provided' }));
				}
				return loginService(attributes)
					.then(result => {
						if (result && result.challengeName) {
							if (result.challengeName === types.NEW_PASSWORD_REQUIRED) {
								const { userAttributes } = result.challengeParam;
								setSessionStorage('useractivestatus', true);
								setLocalStorage('cognito_data', JSON.stringify(userAttributes));
								setLocalStorage('isFirstLogin', "true");
								setLocalStorage('userCreds', JSON.stringify(attributes));
								return dispatch(newPasswordRequired(result));
							}

							return dispatch(loginError({ code: result.challengeName, message: errorMessages.NotAuthorizedException }));
						} else {
							handleLogin(result);
							return dispatch(loginSuccess(result));
						}
					})
					.catch(error => {
						return dispatch(loginError(error));
					})

			default:
				break;
		}
	};
}
